import React, { useEffect, useState } from "react";
import batasFooter from "assets/images/line-footer-2.png";
import LogoPutih from "assets/images/logo_pt_psl_putih_footer.svg";
// import LogoPutih1 from "assets/images/logo_pt_psl_putih1.svg";
import LogoPutih1 from "assets/images/logo_pt_psl_putih_2026.svg";
import footerIg from "assets/images/icons/footer-ig.svg";
import Igicon from "assets/images/icons/instagram1.svg";
import footerTwitter from "assets/images/icons/icons-twitter-fill.svg";
import footerFb from "assets/images/icons/icons-facebook-fill.svg";
import footerLinked from "assets/images/icons/icons-linkedin.svg";
import { uAPI } from "api/config";
import logbase from "assets/images/logbase.png";
import logoBSI from "assets/images/logobsi.png";
import { Link, useLocation } from "react-router-dom";
import { getFooter, getFooterUrlImg } from "redux/global/globalActions";
import useRedux from "redux/useRedux";
import axios from "axios";
import { useTranslation } from 'react-i18next';



const Footer = () => {
  const { t, i18n } = useTranslation(); // Mengakses fungsi terjemahan

  const {
    dispatch,
    global: { footer, footerUrlImg },
    profil: {
      anakPerusahaan: {
        selected
      }
    }
  } = useRedux();

  const location = useLocation();

  useEffect(() => {
    dispatch(getFooter());
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(getFooterUrlImg());
  }, [location]); //eslint-disable-line react-hooks/exhaustive-deps

  let test = footerUrlImg.find((data) => data.menu === location.pathname);
  const objectUrl = uAPI + test?.image;

  // console.log("footer footer", footer);

  return (
    <div className="mt-28">
      <div className="relative">
        {location.pathname === test?.menu ? (
          test?.menu === '/wilayah-kerja-anak-perusahaan' && selected?.footer_image ? (
            <>
              <img className="w-full" src={uAPI + selected?.footer_image} alt={test?.alt} />
            </>
          ) : (
            <>
              <img className="w-full" src={objectUrl} alt={test?.alt} />
            </>
          )
        ) : (
          ""
        )}
      </div>

      <div className="relative bg-footer flex flex-col">
        <img
          className="w-full absolute bottom-[99.6%] left-0"
          src={batasFooter}
          alt="batas-footer"
        />
       
        <div class="section-padding bg-footer-blend grid md:grid-cols-4 gap-10 pb-[70px]">
          <div className="pt-[10px]">
            <img className="" src={LogoPutih1} alt="logo" />
            <div className="text-white text-justify text-[15px]">
             {t('footer01')}
            </div>
            <div className="flex flex-row mt-4">
              {footer && footer?.map((item, i) => {
               if(item.footer_item_type === "Media Social" && item.footer_item_status == "1")  
              {return(
                <>
                  <img
                    className="cursor-pointer mr-[15px]"
                    src={item?.footer_item_icon ? uAPI+item?.footer_item_icon : <></>}
                    alt="icon"
                    width={22}
                    height={22}
                    onClick={() => {
                      item.footer_item_value &&
                        window.open(item.footer_item_value, "_blank");
                    }}
                  />
                </>
                )}
                })
              }
            </div>
          </div>
          <div class="col-span-2 grid md:grid-cols-2 gap-10 pt-[30px]">
            <div className="grid grid-flow-row auto-rows-max gap-x-10 gap-y-6 text-white text-[15px]">
                {footer && <div className="gap-20">
                  {(() => {
                    const mainOfficeItems = footer?.filter(
                      (item) => item.footer_item_type === "Main Office" && item.footer_item_status === "1"
                    );

                    return mainOfficeItems?.length > 0 ? (
                      <div>
                        <div className="font-bold">{mainOfficeItems[0].footer_item_type}</div>
                        {mainOfficeItems.map((item, i) => (
                          <div key={i} className="flex flex-row mb-3">
                            <div
                              className="text-justify cursor-pointer"
                              onClick={() => {
                                window.open(
                                  `https://www.google.com/maps/search/${item?.footer_item_value}`,
                                  "_blank"
                                );
                              }}
                            >
                              {item?.footer_item_value}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : null;
                  })()}

                  {(() => {
                    const emailItems = footer?.filter(
                      (item) => item.footer_item_type === "Email" && item.footer_item_status === "1"
                    );

                    return emailItems?.length > 0 ? (
                      <div>
                        <div className="font-bold">{emailItems[0].footer_item_type}</div>
                        {emailItems.map((item, i) => (
                          <div key={i}>
                            <div
                              className="flex flex-row mb-3"
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                if (item.footer_item_value) {
                                  window.location.href = `mailto:${item.footer_item_value}`;
                                }
                              }}
                            >
                              <div className="">{item.footer_item_value}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : null;
                  })()}

                  {(() => {
                    const ccItems = footer?.filter(
                      (item) => item.footer_item_type === "Customer Care Pelindo" && item.footer_item_status === "1"
                    );

                    return ccItems?.length > 0 ? (
                      <div>
                        <div className="font-bold">{ccItems[0].footer_item_type}</div>
                        {ccItems.map((item, i) => (
                           <>
                            <div key={i}>
                              <div
                                className="flex flex-row mb-3"
                              >
                                {item?.footer_item_icon ? (<img
                                  className="cursor-pointer mr-[15px]"
                                  src={uAPI+item?.footer_item_icon || ""}
                                  alt="icon"
                                  width={25}
                                  height={25}
                                />) : item?.footer_item_name + " : "}
                                <div className="">{item.footer_item_value}</div>
                              </div>
                            </div>
                           </>
                        ))}
                      </div>
                    ) : null;
                  })()}
                </div>}
            </div>
            <div className="grid grid-flow-row auto-rows-max gap-x-10 gap-y-6 text-white text-[15px]">
              <div className="">
                <div className="font-bold">{t('jenis_layanan')}</div>
                <div
                  className="cursor-pointer"
                  onClick={() => window.open("/end-to-end-logistics-services")}
                >
                  End to End Logistics Services
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() =>
                    window.open("/hinterland-development-services")
                  }
                >
                  Hinterland Development Service
                </div>
              </div>
              <div className="">
                <div className="font-bold">
                {t('media_publikasi')}
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => window.open("/kabar-terbaru")}
                >
                  {t('kabar_terbaru')}
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => window.open("/siaran-pers")}
                >
                  {t('siaran_pers')}
                </div>
              </div>
              <div className="">
                <div className="font-bold">
                {t('hubungan_investor')}
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => window.open("/tahunan")}
                >
                  {t('laporan_tahunan')}
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => window.open("/keberlanjutan")}
                >
                  {t('laporan_keberlanjutan')}
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => window.open("/keuangan")}
                >
                  {t('laporan_keuangan')}
                </div>
              </div>
            </div>
          </div>
          <div className="pt-[30px]">
            {/* <div className="text-[15px] text-white font-bold">
              Logistic Marketplace
            </div> */}
            {/* <img src={logbase} className="cursor-pointer" alt="logbase"
              style={{
                width: '100%',
                maxWidth: '180px',
                height: 'auto'
              }}
              onClick={() => {
                window.open("https://logbase.co.id/", "_blank");
              }} /> */}
          </div>

        </div>
        {/* <div className="bg-footer-bottom inline-flex h-[70px] items-center w-full ">
          <div className="section-padding w-full">
            <div className="w-[460px] text-white text-[15px]">
              Copyright © 2026 PT Pelindo Sinergi Lokaseva. All Rights Reserved.
              for the best experience, use Google Chrome.
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
export default Footer;
